import { Button } from "@/components/ui/button";
import Dialog from "@/components/ui/dialog";
import { LoadingCircle } from "@/components/ui/loadingCircle";

interface Props {
  title: string;
  description: string;
  onConfirm: () => void;
  loading: boolean;
  open: boolean;
  setOpen: (v: boolean) => void;
}

export const ConfirmDialog = ({
  open,
  setOpen,
  loading,
  onConfirm,
  title,
  description
}: Props) => {
  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Content className="max-w-lg dark:bg-brand-gray-900">
        <Dialog.Header className="space-y-2 relative">
          <Dialog.Title className="leading-5 text-brand-gray-800 dark:text-brand-gray-100 ">
            {title}
          </Dialog.Title>
          <Dialog.Description className="text-brand-gray-700 dark:text-brand-gray-300">
            {description}
          </Dialog.Description>
        </Dialog.Header>

        <Dialog.Footer className="mt-8">
          <Dialog.Close asChild>
            <Button type="button" variant="secondary">
              Abort
            </Button>
          </Dialog.Close>
          <Button
            type="button"
            variant="destructive"
            onClick={onConfirm}
            disabled={loading}
          >
            Confirm {loading && <LoadingCircle />}
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Root>
  );
};
